import axios from 'axios'
import config from '@/config'

const state = () => ({
  selectedCommunityId: null,
  communityList: []
})

const mutations = {
  SELECT_COMMUNITY(state, payload) {
    state.selectedCommunityId = payload
  },
  SET_ALL_COMMUNITY(state, payload) {
    state.communityList = payload
  }
}

const actions = {
  CHAIRMAN_COMMUNITIES({rootState, commit, rootGetters}) {
    return new Promise((resolve, reject) => {
      axios
        .get(config.APi_URL + 'community/chairman', rootGetters.getRequestConfig)
        .then(response => {
          let storageCommunityId = JSON.parse(localStorage.getItem('vuex'))?.community
            ?.selectedCommunityId
          let emailOld = localStorage.getItem('email-old')
          if (storageCommunityId && rootState.auth.email === emailOld) {
            commit('SELECT_COMMUNITY', storageCommunityId)
          } else {
            commit('SELECT_COMMUNITY', response.data[0].id)
          }
          resolve(response.data)
        })
        .catch(err => {
          commit('SELECT_COMMUNITY', 0)
          reject(err)
        })
    })
  },
  GET_CURRENT_COMMUNITY({getters, rootGetters}) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          config.APi_URL + 'community/' + getters.selectedCommunityId,
          rootGetters.getRequestConfig
        )
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  COMMUNITY_HOUSES({getters, rootGetters}) {
    return new Promise((resolve, reject) => {
      axios
        .get(config.APi_URL + 'house/' + getters.selectedCommunityId, rootGetters.getRequestConfig)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  GET_ALL_COMMUNITY({rootGetters, commit}) {
    return new Promise((resolve, reject) => {
      axios
        .get(config.APi_URL + 'community/all/?page=0&size=100000', rootGetters.getRequestConfig)
        .then(response => {
          commit('SET_ALL_COMMUNITY', response.data)
        })
        .catch(err => reject(err))
    })
  },
  SAVE_COMMUNITY({rootGetters}, community) {
    return new Promise((resolve, reject) => {
      axios
        .post(config.APi_URL + 'community/save', community, rootGetters.getRequestConfig)
        .then(response => {
          resolve(response.data)
        })
        .catch(err => reject(err))
    })
  },
  GET_COMMUNITY_DETAILS({rootGetters}, communityId) {
    return new Promise((resolve, reject) => {
      axios
        .get(config.APi_URL + 'community/details/' + communityId, rootGetters.getRequestConfig)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  }
}

const getters = {
  selectedCommunityId: state => state.selectedCommunityId,
  communityList: state => state.communityList
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
